import { motion, AnimatePresence } from "framer-motion";
import { Activity } from "lucide-react";
import { timeAgo } from "@/lib/format";
import ActivityKindIcon, { stripActivityEmoji } from "@/components/ActivityKindIcon";

const DOT = {
  whale: "bg-sky-400",
  flip: "bg-gold",
  new_number_one: "bg-gold",
  new_entity: "bg-zinc-500",
  contribution: "bg-positive",
};

export default function ActivityFeed({ events }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#080808]" data-testid="activity-feed">
      <div className="flex items-center gap-2 border-b border-white/10 px-4 py-3">
        <Activity className="h-4 w-4 text-positive" strokeWidth={1.5} />
        <span className="text-[11px] font-bold uppercase tracking-[0.2em]">Live activity</span>
        <span className="ml-auto h-2 w-2 rounded-full bg-positive animate-pulse-dot" />
      </div>
      <div className="max-h-[520px] overflow-y-auto">
        <AnimatePresence initial={false}>
          {(events || []).slice(0, 30).map((ev) => (
            <motion.div
              key={ev.id}
              layout
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className="flex items-start gap-3 border-b border-white/5 px-4 py-3"
            >
              <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${DOT[ev.kind] || "bg-zinc-500"}`} />
              <ActivityKindIcon kind={ev.kind} className="mt-0.5 h-3.5 w-3.5" />
              <div className="min-w-0 flex-1">
                <div className="font-mono text-xs leading-relaxed text-zinc-300">
                  {stripActivityEmoji(ev.text)}
                </div>
                <div className="text-[10px] text-zinc-600">{timeAgo(ev.created_at)}</div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
        {(!events || events.length === 0) && (
          <div className="px-4 py-10 text-center text-sm text-zinc-600">No activity yet</div>
        )}
      </div>
    </div>
  );
}
